import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { SbFieldComponent } from './sb-field-utils';

@Component({
    selector: 'app-sb-input',
    template: `
        <span class="ui-float-label">
            <mat-form-field
                style="display: block !important;"
                [class.readonly]="to.readonly"
            >
                <mat-label>{{ to.label }}</mat-label>
                <!-- Latest versions of chrome are ignoring autocomplete="off".
        But are instead ignoring autocomplete if they don't recognize the value of the autocomplete tag -->
                <input
                    matInput
                    autocomplete="dont-autocomplete"
                    [id]="key"
                    [type]="to.type || 'text'"
                    [formControl]="formControl"
                    [formlyAttributes]="field"
                    [class.ng-dirty]="showError"
                    [ngClass]="getClass()"
                    [readonly]="to.readonly"
                    [textMask]="getTextMask()"
                    [required]="to.required"
                    #inputElement
                    (change)="unmask($event.target.value)"
                    (blur)="unmask($event.target.value)"
                    (keypress)="onModelChange(); keyFilter(to.keyFilter, $event)"
                />
            </mat-form-field>
        </span>
    `
})
export class SbInputComponent extends SbFieldComponent implements AfterViewInit {
    @ViewChild('inputElement', { static: true }) input: ElementRef;

    ngAfterViewInit(): void {
        this.input.nativeElement.name = this.getRandomName();
        this.input.nativeElement.setAttribute('data-cy', this.key);
    }

    matchAll() {
        return /(.*?)/;
    }

    unmask(value) {
        if (
            (this.to.type === 'decimal' || this.to.type === 'positive-integer') &&
            value
        ) {
            this.formControl.patchValue(value.replace(/ /gi, ''));
        }

        if (this.field.key === 'email' && this.form.value.email) {
            if (/[A-Z]/.test(this.form.value.email)) {
                this.formControl.patchValue(this.formControl.value.toLowerCase());
            }
        }
    }

    keyFilter(filterType, event) {
        if (filterType) {
            if (filterType === 'num') {
                const charCode = event.which ? event.which : event.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    return false;
                }
                return true;
            } else if (filterType === 'money') {
                var charCode = event.which ? event.which : event.keyCode;
                if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
                    return false;

                return true;
            }
        } else {
            this.matchAll();
        }
    }

    getTooltip() {
        return this.to.tooltip || null;
    }

    getTooltipPosition() {
        return this.to.tooltipPosition || 'top';
    }

    getTooltipEvent() {
        return this.to.tooltipEvent || 'focus';
    }

    onModelChange() {
        if (this.to.type === 'isin' && this.formControl.value) {
            this.formControl.patchValue(this.formControl.value.toUpperCase());
        }
    }

    getTextMask() {
        if (this.to.type === 'decimal') {
            return {
                mask: createNumberMask({
                    prefix: '',
                    allowDecimal: true,
                    thousandsSeparatorSymbol: ' ',
                    decimalLimit: null,
                    allowNegative: this.to.allowNegative
                })
            };
        }
        if (this.to.type === 'positive-integer') {
            return {
                mask: createNumberMask({
                    prefix: '',
                    allowDecimal: false,
                    allowNegative: false,
                    thousandsSeparatorSymbol: ' ',
                    integerLimit: 6
                })
            };
        }
        return { mask: false };
    }
}
